goog.provide("shadow.js.shim.module$src$svg$objects$tag_svg");
goog.provide("module$shadow_js_shim_module$src$svg$objects$tag_svg");
shadow.js.shim.module$src$svg$objects$tag_svg = shadow.js.nativeProvides["src/svg/objects/tag.svg"] = shadow$bridge("src/svg/objects/tag.svg");
module$shadow_js_shim_module$src$svg$objects$tag_svg.default = shadow.js.shim.module$src$svg$objects$tag_svg;
